import { createContext } from 'react';

const initialConfig = {
    components: {},
    menu: []
}

const ConfigContext = createContext(initialConfig);

export default ConfigContext;